<section class="refinement-summary">
  <div class="refinement-summary-heading">
    <span>FILTERS</span>
    @if (activeRefinementCount() > 0) {
      <span class="refinement-count">{{ activeRefinementCount() }}</span>
      <button
        type="button"
        class="clear-all-button"
        (click)="onClearAllRefinements()">
        Clear all
      </button>
    }
  </div>
  @if (activeRefinementCount() > 0) {
    <div class="chips-div">
      @if (chips) {
        @for (chip of object.keys(chips); track chip) {
          <app-shared-chip
            (click)="onRemoveFilterClick(chip)"
            [isChipSelected]="true"
            [matTooltip]="chipTooltip(chip)">
            <span class="refinement-chip-text">{{ chipText(chip) }}</span>
            <span class="refinement-chip-remove" aria-hidden="true">×</span>
          </app-shared-chip>
        }
      }
      @if (hideDisabledItems) {
        <app-shared-chip
          (click)="onHideDisabledToggle(false)"
          [isChipSelected]="true"
          matTooltip="Hide items with the disabled tag. Click to remove">
          <span class="refinement-chip-text">Hide disabled</span>
          <span class="refinement-chip-remove" aria-hidden="true">×</span>
        </app-shared-chip>
      }
      @if (selectedAdvancedFilter?.name) {
        <app-shared-chip
          (click)="onApplyAdvancedFiltersClick(selectedAdvancedFilter)"
          [isChipSelected]="true"
          [matTooltip]="selectedAdvancedFilter.name + '. Click to remove'">
          <span class="refinement-chip-text">{{ selectedAdvancedFilter.name }}</span>
          <span class="refinement-chip-remove" aria-hidden="true">×</span>
        </app-shared-chip>
      }
    </div>
  }
</section>

<label class="hide-disabled-row">
  <input
    id="hide-disabled-items"
    type="checkbox"
    [ngModel]="hideDisabledItems"
    (ngModelChange)="onHideDisabledToggle($event)"/>
  <span>Hide items with disabled tag</span>
</label>

<app-shared-accordion class="accordion-group">
  @if (searchableFields && doFieldExist(searchableFields)) {
    <app-shared-accordion-item
      [isOpen]="openAccordion === 'Searchable Fields'"
      (accordionHeaderClicked)="onAccordionChange($event, 'Searchable Fields')"
    >
      <div class="header">Searchable Fields</div>
      <div class="body">
        <div class="searchable-fields-container">
          @for (key of object.keys(searchableFields); track key) {
            <div class="searchable-fields-item">
              <input
                type="checkbox"
                [ngModel]="searchableFields[key].value"
                (ngModelChange)="onSearchableFieldChange(searchableFields[key], $event)"/>
              <label>{{ searchableFields[key].name }}</label>
            </div>
          }
        </div>
      </div>
    </app-shared-accordion-item>
  }

  @if (searchableDepartments && doFieldExist(searchableDepartments)) {
    <app-shared-accordion-item
      [isOpen]="openAccordion === 'Departments'"
      (accordionHeaderClicked)="onAccordionChange($event, 'Departments')"
    >
      <div class="header">Departments</div>
      <div class="body">
        <input
          type="text"
          class="search"
          placeholder="Search Departments"
          (input)="filterDepartments()"
          [(ngModel)]="searchDepartments"/>
        <div class="faceted-container">
          @for (department of object.keys(filteredDepartments); track department) {
            @if (showsFacet('dep', department, filteredDepartments[department].value)) {
              <div
                class="facet-item">
                <input
                  type="checkbox"
                  [ngModel]="filteredDepartments[department].value"
                  (ngModelChange)="onRefinementValueChange(filteredDepartments[department], $event)"/>
                <label>{{ filteredDepartments[department].name }}</label>
                <span class="badge">{{ facets?.['dep']?.[department] }}</span>
              </div>
            }
          }
        </div>
      </div>
    </app-shared-accordion-item>
  }

  @if (searchableSubDepartments && doFieldExist(searchableSubDepartments)) {
    <app-shared-accordion-item
      [isOpen]="openAccordion === 'Sub-Departments'"
      (accordionHeaderClicked)="onAccordionChange($event, 'Sub-Departments')"
    >
      <div class="header">Sub-Departments</div>
      <div class="body">
        <input
          type="text"
          class="search"
          placeholder="Search Sub-Departments"
          (input)="filterSubDepartments()"
          [(ngModel)]="searchSubDepartments"/>
        <div class="faceted-container">
          @for (subDep of object.keys(filteredSubDepartments); track subDep) {
            @if (showsFacet('subDep', subDep, filteredSubDepartments[subDep].value)) {
              <div
                class="facet-item">
                <input
                  type="checkbox"
                  [ngModel]="filteredSubDepartments[subDep].value"
                  (ngModelChange)="onRefinementValueChange(filteredSubDepartments[subDep], $event)"/>
                <label>{{ filteredSubDepartments[subDep].name }}</label>
                <span class="badge">{{ facets?.['subDep']?.[subDep] }}</span>
              </div>
            }
          }
        </div>
      </div>
    </app-shared-accordion-item>
  }

  @if (suppliers && doFieldExist(suppliers)) {
    <app-shared-accordion-item
      [isOpen]="openAccordion === 'Suppliers'"
      (accordionHeaderClicked)="onAccordionChange($event, 'Suppliers')"
    >
      <div class="header">Suppliers</div>
      <div class="body">
        <input
          type="text"
          class="search"
          placeholder="Search Suppliers"
          (input)="filterSuppliers()"
          [(ngModel)]="searchSuppliers"/>
        <div class="faceted-container">
          @for (supplier of object.keys(filteredSuppliers); track supplier) {
            @if (showsFacet('regularSuppCode', supplier, filteredSuppliers[supplier].value)) {
              <div
                class="facet-item">
                <input
                  type="checkbox"
                  [ngModel]="filteredSuppliers[supplier].value"
                  (ngModelChange)="onRefinementValueChange(filteredSuppliers[supplier], $event)"/>
                <label>{{ filteredSuppliers[supplier].name }}</label>
                <span class="badge">{{ facets?.['regularSuppCode']?.[supplier] }}</span>
              </div>
            }
          }
        </div>
      </div>
    </app-shared-accordion-item>
  }

  @if (multipleSuppliers &&
  doFieldExist(multipleSuppliers) &&
  (facets?.['multipleSuppliers'] || hasSelected(filteredMultipleSuppliers)) &&
  isNonEmptyObject(suppliers)) {
    <app-shared-accordion-item
      [isOpen]="openAccordion === 'Other Suppliers'"
      (accordionHeaderClicked)="onAccordionChange($event, 'Other Suppliers')"
    >
      <div class="header">Other Suppliers</div>
      <div class="body">
        <input
          type="text"
          class="search"
          placeholder="Search Other Suppliers"
          (input)="filterMultipleSuppliers()"
          [(ngModel)]="searchMultipleSuppliers"/>
        <div class="faceted-container">
          @for (key of object.keys(filteredMultipleSuppliers); track key) {
            @if (showsFacet('multipleSuppliers', key, filteredMultipleSuppliers[key].value)) {
              <div
                class="facet-item">
                <input
                  type="checkbox"
                  [ngModel]="filteredMultipleSuppliers[key].value"
                  (ngModelChange)="onRefinementValueChange(filteredMultipleSuppliers[key], $event)"/>
                <label>{{ multipleSuppliers[key].name }}</label>
                <span class="badge">{{ facets?.['multipleSuppliers']?.[key] }}</span>
              </div>
            }
          }
        </div>
      </div>
    </app-shared-accordion-item>
  }

  @if (tags && doFieldExist(tags) && (facets?.['_tags'] || hasSelected(tags))) {
    <app-shared-accordion-item
      [isOpen]="openAccordion === 'Tags'"
      (accordionHeaderClicked)="onAccordionChange($event, 'Tags')"
    >
      <div class="header">Tags</div>
      <div class="body">
        <div class="faceted-container">
          @for (key of object.keys(tags); track key) {
            @if (showsFacet('_tags', key, tags[key].value)) {
              <div
                class="facet-item">
                <input
                  type="checkbox"
                  [ngModel]="tags[key].value"
                  (ngModelChange)="onRefinementValueChange(tags[key], $event)"/>
                <label>{{ key }}</label>
                <span class="badge">{{ facets?.['_tags']?.[key] }}</span>
              </div>
            }
          }
        </div>
      </div>
    </app-shared-accordion-item>
  }


  @if (!hideLineColours &&
  isNonEmptyObject(lineColours) &&
  lineColourCodes &&
  doFieldExist(lineColourCodes)) {
    <app-shared-accordion-item
      [isOpen]="openAccordion === 'Line Colour Codes'"
      (accordionHeaderClicked)="onAccordionChange($event, 'Line Colour Codes')"
    >
      <div class="header">Line Colour Codes</div>
      <div class="body">
        <div class="faceted-container">
          @for (key of lineColourOptionKeys(); track key) {
            @if (showsLineColour(key)) {
              <div
                class="facet-item"
                [style.background]="lineColourBackground(key)">
                <input
                  type="checkbox"
                  [ngModel]="lineColourCodes[key].value"
                  (ngModelChange)="onRefinementValueChange(lineColourCodes[key], $event)"/>
                <label>
                  {{ lineColourLabel(key) }}
                </label>
                @if (facets?.['lineColourCode']?.[key] != null) {
                  <span class="badge">{{ facets?.['lineColourCode']?.[key] }}</span>
                }
              </div>
            }
          }
        </div>
      </div>
    </app-shared-accordion-item>
  }


  @if (advancedFilters?.length > 0) {
    <app-shared-accordion-item
      [isOpen]="openAccordion === 'Apply Saved Filters'"
      (accordionHeaderClicked)="onAccordionChange($event, 'Apply Saved Filters')"
    >
      <div class="header">Apply Saved Filters</div>
      <div class="body">
        <div class="faceted-container">
          @for (filter of advancedFilters; track $index) {
            <div
              (click)="onApplyAdvancedFiltersClick(filter)"
              (keydown.enter)="onApplyAdvancedFiltersClick(filter)"
              (keydown.space)="onApplyAdvancedFiltersClick(filter)"
              class="facet-item saved-filter-item"
              [class.selected]="filter.name === selectedFilterName"
              [attr.aria-pressed]="filter.name === selectedFilterName"
              role="button"
              tabindex="0">
              <input
                type="checkbox"
                [checked]="filter.name === selectedFilterName"/>
              <label>{{ filter.name }}</label>
            </div>
          }
        </div>
      </div>
    </app-shared-accordion-item>
  }
</app-shared-accordion>
